import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

const quoteComponents = require.context('./Components/QuoteSteps', true, /[A-Z]\w+\.(vue)$/,);

quoteComponents.keys().forEach(fileName => {
	const componentConfig = quoteComponents(fileName);
	let rawName = fileName.replace('./', '').replace(/\.\w+$/, '').split('/');

	if(rawName.length > 1) {
		rawName = `${rawName.shift()}_Quote_${rawName.join('_')}`;
	}

	else {
        rawName = `Quote_${rawName.pop()}`;
	}

	const componentName = upperFirst(camelCase(rawName));

	// console.log(componentName);

	Vue.component(componentName, componentConfig.default || componentConfig);
});

const formComponents = require.context('./Components/Forms', false, /[A-Z]\w+\.(vue)$/,);

formComponents.keys().forEach(fileName => {
	const componentConfig = formComponents(fileName);
	const componentName = 'App'+upperFirst(camelCase(fileName.split('/').pop().replace(/\.\w+$/, '')));

	Vue.component(componentName, componentConfig.default || componentConfig);
});
